
import { useState } from "react"
import { Button } from "@/components/ui/button"
import { Loader2 } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog"

interface FormModalProps {
  children?: React.ReactNode
  title: string
  description: string
  triggerButton?: React.ReactNode
  onSubmit: (e: React.FormEvent) => Promise<void> | void
  submitButtonText?: string
  loading?: boolean
  open?: boolean
  onOpenChange?: (open: boolean) => void
  formContent: React.ReactNode
}

const FormModal = ({ 
  children, 
  title, 
  description, 
  triggerButton,
  onSubmit,
  submitButtonText = "Salvar",
  loading = false,
  open,
  onOpenChange,
  formContent
}: FormModalProps) => {
  const [internalOpen, setInternalOpen] = useState(false)
  
  const isControlled = open !== undefined && onOpenChange !== undefined
  const modalOpen = isControlled ? open : internalOpen
  const setModalOpen = isControlled ? onOpenChange : setInternalOpen

  return (
    <Dialog open={modalOpen} onOpenChange={setModalOpen}>
      <DialogTrigger asChild>
        {children || triggerButton}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit}>
          <div className="grid gap-4 py-4">
            {formContent}
          </div>
          <DialogFooter>
            <Button type="submit" disabled={loading}>
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
              {submitButtonText}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export { FormModal }
